export interface FactoryProduct {
  id: string;
  name: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  category: string;
}

export interface Factory {
  id: string;
  name: string;
  city: string;
  established: number;
  employees: string;
  verified: boolean;
  dropshipping: boolean;
  warehouseCountries?: string[];
  rating: number;
  responseRate: string;
  onTimeDelivery: string;
  productCount: number;
  categories: string[];
  description: string;
  logo: string;
  coverImage: string;
  products: FactoryProduct[];
}

export const qatarFactories: Factory[] = [
  {
    id: "qf1",
    name: "Qatar Premium Exports LLC",
    city: "Doha",
    established: 2015,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Qatar", "UAE", "UK", "Germany", "USA"],
    rating: 4.7,
    responseRate: "92%",
    onTimeDelivery: "96%",
    productCount: 560,
    categories: ["Food & Beverage", "Packaging", "Chemicals"],
    description: "Qatar-based exporter specializing in food-grade packaging and chemical products. Halal certified with global dropshipping from 5 warehouse locations.",
    logo: "https://public.readdy.ai/ai/img_res/ddac2d6f79fa582afb0e326723b5b072.jpg",
    coverImage: "https://readdy.ai/api/search-image?query=Qatar%20Doha%20modern%20factory%20interior%20production%20packaging%20food%20grade%20professional%20bright%20clean%20workers&width=800&height=400&seq=qfc1&orientation=landscape",
    products: [
      {
        id: "qf1p1",
        name: "Food-Grade Packaging Containers Set",
        samplePrice: 8,
        bulkPrice: 2,
        moq: 500,
        category: "Packaging",
        image: "https://readdy.ai/api/search-image?query=food%20grade%20packaging%20containers%20set%20clear%20plastic%20white%20background%20product%20photography%20professional%20clean%20minimal&width=400&height=400&seq=qf1p1&orientation=squarish",
      },
      {
        id: "qf1p2",
        name: "Qatar Halal Certified Food Pack",
        samplePrice: 45,
        bulkPrice: 15,
        moq: 50,
        category: "Food & Beverage",
        image: "https://readdy.ai/api/search-image?query=Qatar%20halal%20certified%20food%20pack%20premium%20packaging%20white%20background%20product%20photography%20professional%20clean&width=400&height=400&seq=qf1p2&orientation=squarish",
      },
      {
        id: "qf1p3",
        name: "Industrial Chemical Drums 200L",
        samplePrice: 220,
        bulkPrice: 85,
        moq: 10,
        category: "Chemicals",
        image: "https://readdy.ai/api/search-image?query=industrial%20chemical%20drums%20200L%20blue%20white%20background%20product%20photography%20professional%20clean%20industrial%20storage&width=400&height=400&seq=qf1p3&orientation=squarish",
      },
    ],
  },
  {
    id: "qf2",
    name: "Doha Steel & Metal Works",
    city: "Doha",
    established: 2005,
    employees: "200–500",
    verified: true,
    dropshipping: false,
    rating: 4.6,
    responseRate: "90%",
    onTimeDelivery: "93%",
    productCount: 420,
    categories: ["Steel", "Metal", "Construction"],
    description: "Heavy-duty steel and metal fabrication for construction and industrial projects. Supplying structural steel, custom metal works, and construction materials.",
    logo: "https://readdy.ai/api/search-image?query=steel%20metal%20works%20company%20logo%20gold%20industrial%20emblem%20white%20background%20Qatar%20construction%20manufacturing%20corporate&width=80&height=80&seq=qfl2&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Doha%20Qatar%20steel%20metal%20factory%20production%20workers%20welding%20construction%20materials%20professional%20bright%20industrial&width=800&height=400&seq=qfc2&orientation=landscape",
    products: [
      {
        id: "qf2p1",
        name: "Stainless Steel Structural Beams",
        samplePrice: 450,
        bulkPrice: 180,
        moq: 5,
        category: "Steel",
        image: "https://readdy.ai/api/search-image?query=stainless%20steel%20structural%20beams%20industrial%20metal%20construction%20material%20white%20background%20product%20photography%20professional&width=400&height=400&seq=qf2p1&orientation=squarish",
      },
      {
        id: "qf2p2",
        name: "Galvanized Steel Pipes (6m)",
        samplePrice: 85,
        bulkPrice: 32,
        moq: 20,
        category: "Construction",
        image: "https://readdy.ai/api/search-image?query=galvanized%20steel%20pipes%206m%20construction%20material%20white%20background%20product%20photography%20professional%20industrial%20metal&width=400&height=400&seq=qf2p2&orientation=squarish",
      },
      {
        id: "qf2p3",
        name: "Custom Metal Fabrication Parts",
        samplePrice: 220,
        bulkPrice: 80,
        moq: 10,
        category: "Metal",
        image: "https://readdy.ai/api/search-image?query=custom%20metal%20fabrication%20parts%20industrial%20precision%20white%20background%20product%20photography%20professional%20manufacturing&width=400&height=400&seq=qf2p3&orientation=squarish",
      },
    ],
  },
  {
    id: "qf3",
    name: "Qatar Petrochemical Industries",
    city: "Mesaieed",
    established: 1998,
    employees: "1000+",
    verified: true,
    dropshipping: false,
    rating: 4.8,
    responseRate: "94%",
    onTimeDelivery: "95%",
    productCount: 890,
    categories: ["Chemicals", "Plastics", "Industrial"],
    description: "One of Qatar's largest petrochemical manufacturers. Producing industrial-grade chemicals, plastics, and polymers for global manufacturing industries.",
    logo: "https://readdy.ai/api/search-image?query=petrochemical%20company%20logo%20gold%20molecule%20emblem%20white%20background%20Mesaieed%20Qatar%20corporate%20identity%20professional%20industrial&width=80&height=80&seq=qfl3&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Mesaieed%20Qatar%20petrochemical%20industrial%20plant%20production%20professional%20bright%20clean%20modern%20aerial%20view%20factory&width=800&height=400&seq=qfc3&orientation=landscape",
    products: [
      {
        id: "qf3p1",
        name: "LDPE Plastic Granules 25kg",
        samplePrice: 65,
        bulkPrice: 22,
        moq: 100,
        category: "Plastics",
        image: "https://readdy.ai/api/search-image?query=LDPE%20plastic%20granules%2025kg%20bag%20industrial%20white%20background%20product%20photography%20professional%20clean%20manufacturing&width=400&height=400&seq=qf3p1&orientation=squarish",
      },
      {
        id: "qf3p2",
        name: "Industrial Solvent 200L Drum",
        samplePrice: 280,
        bulkPrice: 110,
        moq: 5,
        category: "Chemicals",
        image: "https://readdy.ai/api/search-image?query=industrial%20solvent%20200L%20drum%20chemical%20white%20background%20product%20photography%20professional%20clean%20industrial%20storage&width=400&height=400&seq=qf3p2&orientation=squarish",
      },
      {
        id: "qf3p3",
        name: "Polypropylene Sheets 4x8ft",
        samplePrice: 45,
        bulkPrice: 16,
        moq: 50,
        category: "Plastics",
        image: "https://readdy.ai/api/search-image?query=polypropylene%20sheets%204x8ft%20plastic%20industrial%20white%20background%20product%20photography%20professional%20clean%20manufacturing&width=400&height=400&seq=qf3p3&orientation=squarish",
      },
    ],
  },
  {
    id: "qf4",
    name: "Al Rayyan Textile Factory",
    city: "Al Rayyan",
    established: 2019,
    employees: "50–100",
    verified: false,
    dropshipping: true,
    warehouseCountries: ["Qatar", "UAE", "Turkey"],
    rating: 4.2,
    responseRate: "82%",
    onTimeDelivery: "85%",
    productCount: 230,
    categories: ["Textiles", "Uniforms", "Sportswear"],
    description: "Growing textile manufacturer in Al Rayyan offering custom uniforms, sportswear, and branded clothing with competitive pricing and dropshipping support.",
    logo: "https://readdy.ai/api/search-image?query=textile%20company%20logo%20gold%20thread%20emblem%20white%20background%20Al%20Rayyan%20Qatar%20fabric%20manufacturing%20corporate%20identity&width=80&height=80&seq=qfl4&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Al%20Rayyan%20Qatar%20textile%20factory%20sewing%20machines%20workers%20clothing%20production%20professional%20bright%20interior%20modern&width=800&height=400&seq=qfc4&orientation=landscape",
    products: [
      {
        id: "qf4p1",
        name: "FIFA World Cup Style Jersey",
        samplePrice: 28,
        bulkPrice: 10,
        moq: 30,
        category: "Sportswear",
        image: "https://readdy.ai/api/search-image?query=FIFA%20World%20Cup%20style%20jersey%20football%20shirt%20professional%20white%20background%20product%20photography%20clean%20sportswear&width=400&height=400&seq=qf4p1&orientation=squarish",
      },
      {
        id: "qf4p2",
        name: "Hotel Staff Uniform Set",
        samplePrice: 55,
        bulkPrice: 20,
        moq: 20,
        category: "Uniforms",
        image: "https://readdy.ai/api/search-image?query=hotel%20staff%20uniform%20set%20professional%20elegant%20white%20background%20product%20photography%20clean%20workwear%20hospitality&width=400&height=400&seq=qf4p2&orientation=squarish",
      },
      {
        id: "qf4p3",
        name: "Custom Embroidered Polo Shirt",
        samplePrice: 22,
        bulkPrice: 8,
        moq: 50,
        category: "Uniforms",
        image: "https://readdy.ai/api/search-image?query=custom%20embroidered%20polo%20shirt%20professional%20white%20background%20product%20photography%20clean%20corporate%20workwear&width=400&height=400&seq=qf4p3&orientation=squarish",
      },
    ],
  },
  {
    id: "qf5",
    name: "Qatar Food Industries Co.",
    city: "Doha",
    established: 2008,
    employees: "200–500",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Qatar", "UAE", "Saudi Arabia", "UK"],
    rating: 4.7,
    responseRate: "93%",
    onTimeDelivery: "94%",
    productCount: 380,
    categories: ["Food", "Beverages", "Dairy"],
    description: "Qatar's leading food and beverage manufacturer. Producing halal-certified dairy, juices, and packaged foods for global retail and wholesale markets.",
    logo: "https://readdy.ai/api/search-image?query=food%20company%20logo%20gold%20wheat%20emblem%20white%20background%20Qatar%20food%20industries%20corporate%20identity%20professional&width=80&height=80&seq=qfl5&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Qatar%20food%20factory%20Doha%20production%20line%20dairy%20beverages%20workers%20professional%20bright%20clean%20modern%20interior&width=800&height=400&seq=qfc5&orientation=landscape",
    products: [
      {
        id: "qf5p1",
        name: "Qatar Dairy Products Bulk (24 units)",
        samplePrice: 35,
        bulkPrice: 12,
        moq: 100,
        category: "Dairy",
        image: "https://readdy.ai/api/search-image?query=Qatar%20dairy%20products%20bulk%20premium%20packaging%20white%20background%20product%20photography%20professional%20clean%20food&width=400&height=400&seq=qf5p1&orientation=squarish",
      },
      {
        id: "qf5p2",
        name: "Halal Fruit Juice Pack (12 bottles)",
        samplePrice: 22,
        bulkPrice: 8,
        moq: 200,
        category: "Beverages",
        image: "https://readdy.ai/api/search-image?query=halal%20fruit%20juice%20pack%2012%20bottles%20premium%20packaging%20white%20background%20product%20photography%20professional%20clean%20food&width=400&height=400&seq=qf5p2&orientation=squarish",
      },
      {
        id: "qf5p3",
        name: "Premium Mineral Water 500ml (24pcs)",
        samplePrice: 12,
        bulkPrice: 4,
        moq: 500,
        category: "Beverages",
        image: "https://readdy.ai/api/search-image?query=premium%20mineral%20water%20500ml%2024%20pack%20bottles%20white%20background%20product%20photography%20professional%20clean%20beverage&width=400&height=400&seq=qf5p3&orientation=squarish",
      },
    ],
  },
  {
    id: "qf6",
    name: "Lusail Smart Tech Factory",
    city: "Lusail",
    established: 2020,
    employees: "100–200",
    verified: true,
    dropshipping: true,
    warehouseCountries: ["Qatar", "UAE", "USA", "Germany", "Singapore"],
    rating: 4.8,
    responseRate: "96%",
    onTimeDelivery: "95%",
    productCount: 670,
    categories: ["Electronics", "Smart Home", "IoT"],
    description: "Cutting-edge smart technology manufacturer in Lusail City. Producing IoT devices, smart home systems, and connected electronics for global markets.",
    logo: "https://readdy.ai/api/search-image?query=smart%20tech%20company%20logo%20gold%20circuit%20emblem%20white%20background%20Lusail%20Qatar%20technology%20corporate%20identity%20modern&width=80&height=80&seq=qfl6&orientation=squarish",
    coverImage: "https://readdy.ai/api/search-image?query=Lusail%20Qatar%20smart%20tech%20factory%20clean%20room%20production%20IoT%20devices%20electronics%20professional%20bright%20modern%20interior&width=800&height=400&seq=qfc6&orientation=landscape",
    products: [
      {
        id: "qf6p1",
        name: "Smart Home IoT Hub Device",
        samplePrice: 130,
        bulkPrice: 55,
        moq: 10,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=smart%20home%20IoT%20hub%20device%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20electronics&width=400&height=400&seq=qf6p1&orientation=squarish",
      },
      {
        id: "qf6p2",
        name: "Wireless Smart Doorbell Camera",
        samplePrice: 75,
        bulkPrice: 28,
        moq: 20,
        category: "Smart Home",
        image: "https://readdy.ai/api/search-image?query=wireless%20smart%20doorbell%20camera%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech%20security&width=400&height=400&seq=qf6p2&orientation=squarish",
      },
      {
        id: "qf6p3",
        name: "Smart Energy Monitor Plug",
        samplePrice: 35,
        bulkPrice: 12,
        moq: 50,
        category: "IoT",
        image: "https://readdy.ai/api/search-image?query=smart%20energy%20monitor%20plug%20IoT%20device%20modern%20white%20background%20product%20photography%20professional%20tech%20electronics&width=400&height=400&seq=qf6p3&orientation=squarish",
      },
    ],
  },
];
